<template>
    <tr>
        <td class="mini">{{theBanner.id}}</td>
        <td class="big">{{theBanner.name}}</td>
        <td class="big"> <div class="banner-locker"><img :src="image" alt=""></div></td>
        <td class="big">
            <custom-input kind="text" key="8" container="full-width" classes="full-width" v-bind:theModel.sync="theBanner.link" placeholder="لینک"></custom-input>
        </td>
        <td class="big">
          <button class="purple-btn" @click="editPic">ویرایش</button>
          <button class="purple-btn mt-1" @click="editMe">ثبت تغییرات</button>
          <input type="file" class="hidden-input" id="img" name="img" accept="image/*" @change="(e)=>setNewImage(e)">
        </td>
    </tr>
</template>
<script>
import CustomInput from '../../../Common/CustomInput.vue'
export default {
    props:['theBanner'],
    methods:{
        editPic(){
            document.getElementById('img').click()
        },
        editMe(){
            if(this.theBanner.link.value != this.link){
                this.theBanner.editLink = true
            }
            this.$emit('editMe',this.theBanner)
        },
        setNewImage(e){
            console.log(e)
            this.image = URL.createObjectURL(e.target.files[0])
            this.theBanner.image = e.target.files[0]
            this.theBanner.editPic = true
        }
    },
    components:{
        CustomInput
    },
    mounted(){
        this.image = this.theBanner.image
        this.theBanner.editPic = false
        this.theBanner.editLink = false
        this.link = this.theBanner.link.value
    },
    data:()=>({
        image:null,
        link:null
    })
}
</script>
<style scoped>
td{
    border:1px solid rgb(218, 218, 218);
    text-align: center;
    padding:5px;
}
.hidden-input{
    display: none;
}
.mini{
    max-width: 40px;
}
.medium{
    max-width: 100px;
}
.big{
    min-width: 100px;
}
</style>
